import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "services/principal/customFetchBase";

export const modalidadTitulacionApi = createApi({
  reducerPath: "modalidadTitulacionApi",
  baseQuery: customFetchBase,
  tagTypes: ["ModalidadTitulacion"],
  endpoints: (builder) => ({
    getModalidadesTitulacion: builder.query({
      query: () => ({
        url: "/v1/api/modalidadtitulacion/",
        method: "GET",
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "ModalidadTitulacion",
                id,
              })),
              { type: "ModalidadTitulacion", id: "LIST" },
            ]
          : [{ type: "ModalidadTitulacion", id: "LIST" }],
    }),
    getModalidadTitulacion: builder.query({
      query: (id) => ({
        url: `/v1/api/modalidadtitulacion/${id}/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "ModalidadTitulacion", id }],
    }),
  }),
});

export const {
  useGetModalidadesTitulacionQuery,
  useGetModalidadTitulacionQuery,
} = modalidadTitulacionApi;
